import getDomain from './get-domain';

const domain = getDomain();
export const ANALYTICS_URL = `${process.env.ANALYTICS_ROOT}v3/${domain}/ingest`;
export const BOOTSTRAP_URL = `${process.env.BOOTSTRAP_ROOT}v2/${domain}/bootstrap/v2`;
